<!--
 * @Author: your name
 * @Date: 2021-06-04 14:46:26
 * @LastEditTime: 2021-06-04 17:16:41
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \e6-module-order-waybill-process\src\e6-module-order-waybill-process\views\rules\delegateRule\add.vue
-->
<template>
  <add-or-update :pageType="0" />
</template>

<script>
import addOrUpdate from "./components/addOrUpdate";
export default {
  name: "delegateRuleAdd",
  components: { addOrUpdate }
};
</script>
